import { COUNTRIES_REQUIRING_TAX_IDENTIFIER } from 'resources/wallet/constants'

export const useTransactionTaxInfo = (country_iso2: string) => {
  return COUNTRIES_REQUIRING_TAX_IDENTIFIER.includes(country_iso2)
    ? 'Supply subject to reverse charge – VAT/GST to be accounted for by the recipient as per local regulations.'
    : null
}
